exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".button---2FK0U {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 220px;\n  height: 40px;\n  margin-right: 15px;\n  border-radius: 40px;\n  color: #fff;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(103.65deg, #00abe8 -2.03%, #007acc 43.7%, #0063a7 105.46%);\n  cursor: pointer; }\n  .button---2FK0U .icon---6rIcc {\n    width: 16px;\n    height: 16px;\n    margin-right: 8px; }\n  .button---2FK0U[disabled] {\n  cursor: default; }\n", ""]);

// exports
exports.locals = {
	"button": "button---2FK0U",
	"icon": "icon---6rIcc"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/certificates/components/certificate-confirmation-modal/components/download-button/download-button.scss
// module id = 4Hqn
// module chunks = 1